import i18n from "i18next"
import { initReactI18next } from "react-i18next"

import en_common from "../locales/en/common.json"
import en_BlogPage from "../locales/en/BlogPage.json"
import en_ContactPage from "../locales/en/ContactPage.json"
import en_NotFoundPage from "../locales/en/NotFoundPage.json"
import en_PainterPage from "../locales/en/PainterPage.json"
import en_PsychologistPage from "../locales/en/PsychologistPage.json"

import it_common from "../locales/it/common.json"
import it_BlogPage from "../locales/it/BlogPage.json"
import it_ContactPage from "../locales/it/ContactPage.json"
import it_NotFoundPage from "../locales/it/NotFoundPage.json"
import it_PainterPage from "../locales/it/PainterPage.json"
import it_PsychologistPage from "../locales/it/PsychologistPage.json"

// All translations are bundled inline — no async HTTP loading, so language
// switching is always instant regardless of navigation order.

i18n
    .use(initReactI18next)
    .init({
        lng: "it",
        fallbackLng: "it",

        resources: {
            en: {
                common: en_common,
                BlogPage: en_BlogPage,
                ContactPage: en_ContactPage,
                NotFoundPage: en_NotFoundPage,
                PainterPage: en_PainterPage,
                PsychologistPage: en_PsychologistPage,
            },
            it: {
                common: it_common,
                BlogPage: it_BlogPage,
                ContactPage: it_ContactPage,
                NotFoundPage: it_NotFoundPage,
                PainterPage: it_PainterPage,
                PsychologistPage: it_PsychologistPage,
            },
        },

        keySeparator: false,
        defaultNS: "common",
        debug: process.env.NODE_ENV === 'development',
        interpolation: {
            escapeValue: false,
        },
        react: {
            useSuspense: false,
        },
    })

export default i18n